import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MyBookingTabShow } from '@common/helpers/enums/servicing.enum';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingService } from '@common/services/my-booking/my-booking.service';
import { SupportComponent } from '@lib/components/support-class/support-component';
import { StaticMsgPipe } from '@lib/pipes/static-msg/static-msg.pipe';
import { CommonLibService } from '@lib/services/common-lib/common-lib.service';
import { Observable, Subscription } from 'rxjs';
import { GetOrderResponse, GetOrderResponseData } from 'src/sdk-servicing';
import { MyBookingTabsComponent } from '../sub-components/tab/my-booking-tabs.component';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { MyBooking } from '@common/interfaces/mybooking/mybooking.interface';
import { NextActionService } from '@common/services/next-action/next-action.service';
import { NextActionTypeEnum } from '@common/services/next-action/next-action.constants';
import { AppConstants } from '@conf/app.constants';

@Component({
  selector: 'asw-my-booking-pres',
  templateUrl: './my-booking-pres.component.html',
  styleUrls: ['./my-booking-pres.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBookingPresComponent extends SupportComponent {
  MY_BOOKING_TAB_SHOW_Itinerary = MyBookingTabShow.MyBookingTabShowEnum.Itinerary;
  MY_BOOKING_TAB_SHOW_Traveler = MyBookingTabShow.MyBookingTabShowEnum.Traveler;
  MY_BOOKING_TAB_SHOW_Service = MyBookingTabShow.MyBookingTabShowEnum.Service;
  _beforePaymentOrder: GetOrderResponse = {};
  _pnr!: GetOrderResponseData;
  _subscription: Subscription = new Subscription();
  // 1.2 eチケット
  displayEMD: boolean = false;
  /**
   * 1.1 予約詳細ヘッダ
   * 1.1 詳細内容表示切り替え
   */
  myBooking$: Observable<MyBooking>;

  isDisplayReservation: boolean = false;

  /** 定数用 */
  public appConstants = AppConstants;

  @ViewChild('myBookingTabComponent') myBookingTabComponent!: MyBookingTabsComponent;
  constructor(
    private _common: CommonLibService,
    public change: ChangeDetectorRef,
    public staticMsg: StaticMsgPipe,
    public myBookingService: MyBookingService,
    public myBookingStoreService: MyBookingStoreService,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private cdr: ChangeDetectorRef,
    private readonly _nextActionService: NextActionService
  ) {
    super(_common);
    this.myBooking$ = this.myBookingStoreService.getMyBookingModel$();
  }

  init() {
    this._subscription.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        this._pnr = (servicingCommon.getOrder ?? {}) as GetOrderResponseData;
        const conditionContainer = this._pnr?.orderEligibilities?.eticketAndEmd;
        // PNR情報取得API応答.data.orderEligibilities.usageDetailsListOfBusinessTrip.isEligibleToForward=true(案内必要)の場合、ANA Biz ご利用明細書の文言を表示する。
        this.displayEMD = conditionContainer?.isEligibleToForward ?? false;
        this.cdr.markForCheck();
      })
    );
    this._subscription.add(
      this.myBookingStoreService.getMyBookingModel$().subscribe((mybooking) => {
        // hide while loading
        this.isDisplayReservation = mybooking.isDisplayReservation ?? false;
      })
    );
  }

  destroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
  reload() {}

  get pnr() {
    return this._pnr;
  }

  /** (3) 詳細内容表示切り替えタブ押下処理 */
  onGetTabClick(activeNum: string) {
    // 1.	予約詳細表示タブ変数に、タブ種別を設定する。
    this.myBookingService.tabShow = activeNum;
    // 2.	[当画面共通処理No1.表示タブ切り替え処理]を行う。
    this.myBookingService.onHandleCommonNo1();
  }

  clickETicketAndEmd() {
    this._nextActionService.onHandleETicketAndEMD(
      {
        orderId: this._pnr?.orderId!,
        firstName: this._common.aswServiceStoreService.aswServiceData?.firstName!,
        lastName: this._common.aswServiceStoreService.aswServiceData?.lastName!,
        nextAction: NextActionTypeEnum.EticketAndEmd,
      },
      this._pnr
    );
  }
}
